
import {
    GrpcService,
    HttpRequestDelegate,
} from "../../../grpc"

import {
    Timestamp,
} from "../../../google/protobuf/timestamp"

import {
    BoolValue,
} from "../../../google/protobuf/wrappers"

export interface GetStatisticsRequest {
    organizationId: number /* 机构ID */
    startTime: Timestamp /* 统计开始时间 */
    endTime: Timestamp /* 统计结束时间 */
}

export interface GetStatisticsResponse {
    statisticsDataCsvUrl: string /* 统计数据 */
}

export interface HasStatisticsRequest {
    organizationId: number /* 机构ID */
}

export class StatisticsService extends GrpcService {
    constructor(host: string, httpRequestDelegate: HttpRequestDelegate) {
        super(host, httpRequestDelegate)
    }
    
    /* 获取统计数据 */
    async getStatistics(request: GetStatisticsRequest): Promise<GetStatisticsResponse> {
        const method = "post"
        const path = "/scanner.v2.StatisticsService/GetStatistics"
        return await this.call(method, path, request) as GetStatisticsResponse
    }
    
    /* 是否有统计数据功能 */
    async hasStatistics(request: HasStatisticsRequest): Promise<BoolValue> {
        const method = "post"
        const path = "/scanner.v2.StatisticsService/HasStatistics"
        return await this.call(method, path, request) as BoolValue
    }
    
}
